<template>
  <section>
    <div class="content1">
      <div class="title">
        {{ title }}
      </div>
      <div>
        <span v-if="obj">
          <el-scrollbar wrap-style="overflow-x: hidden;">
            <div class="coontent" v-html="obj.content" />
          </el-scrollbar>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoContent1',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeTab: true
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
  }
}
</script>

<style scoped lang="scss">
.coontent{
  padding-bottom: 50px;
}
.content1 {
  padding: 32px 40px 32px 50px;
  height: 100%;
  display: flex;
  flex-direction: column;
  > div {
    .title {
      @include fun-border(0,"bottom");
      height: 26px;
      width: 100%;
      font-size: 14px;
      @include fun-design(4);
    }
    &:nth-child(2) {
      flex: 1;
      width: 100%;
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      > span {
        width: 100%;
        &:nth-child(2) {
          flex: 1;
        }
      }

    }
  }
}
</style>
